import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
	providedIn: 'root'
})
export class ProductsService {

	constructor(
		private http: HttpClient) { }



	getProducts(commerce) {
			return this.http.get<any[]>(`${environment.apiUrl}/commerces/${commerce}/products`)
			.pipe(
				map(response => {
					// Aquí puedes transformar los datos si es necesario
					return response.map(item => ({
						key: item.id, // Si tu API devuelve un id, puedes mapearlo como key
						...item
					}));
				})
			);

	}

	getProductByCommerce(commerce) {
			return this.http.get(`${environment.apiUrl}/products`,{params: {commerce: commerce}}).pipe(
				map((products: any) => products)
			);

	}

	getProductByCategory(category) {
			return this.http.get(`${environment.apiUrl}/products`,{params: {category: category}}).pipe(
				map((products: any) => products)
			);

	}

	getProductById(commerce, keyProduct) {
			return this.http.get(`${environment.apiUrl}/commerces/${commerce}/products/${keyProduct}`).pipe(
				map((product: any) => product)
			);

	}


}
